import { atom } from '@reatom/framework'

import { isAdminAtom, isLoggedInAtom } from '@root/entities/auth'

import { supportTicketsModel } from './reatom-support-ticket'
import { supportTicketsModelAdmin } from './reatom-support-ticket-admin'

import type { SupportTicket } from '../model/support-ticket'

type SupportScreen =
  | {
      screen: 'create'
    }
  | {
      screen: 'conversation'
      ticket: SupportTicket
    }
  | {
      screen: 'tickets'
    }

const initScreen: SupportScreen = {
  screen: 'tickets',
}
export const supportDialogScreenAtom = atom<SupportScreen>(
  initScreen,
  'supportDialogScreenAtom',
)

export const supportDialogOnlineAtom = atom<boolean>(
  false,
  'supportDialogOnlineAtom',
)

export const supportDialogTypingAtom = atom<boolean>(
  false,
  'supportDialogTypingAtom',
)

export const supportTicketTotalUnread = atom((ctx): number => {
  const isLoggedIn = ctx.spy(isLoggedInAtom)
  const isAdmin = ctx.spy(isAdminAtom)

  if (!isLoggedIn) {
    return 0
  }
  if (isAdmin) {
    const totals = ctx.spy(supportTicketsModelAdmin.totals)

    return totals.unreadTickets
  }

  return ctx.spy(supportTicketsModel.totalUnreadCount)
}, 'supportTicketTotalUnread')
